import { 
  Button, 
  Container, 
  FormControl, 
  FormLabel, 
  Heading, 
  Input, 
  Stack, 
  Text,
  useToast,
  Link
} from "@chakra-ui/react"
import { createFileRoute, Link as RouterLink } from "@tanstack/react-router"
import { useState } from "react"
import { PublicService } from "../client"
import { getBaseDomain } from "../utils/urls"

export const Route = createFileRoute("/subdomain")({
  component: DomainEntry,
})

function DomainEntry() {
  const [domain, setDomain] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleContinue = async () => {
    if (!domain) return
    setIsLoading(true)
    
    try {
      // Validate subdomain existence with the backend
      const check = await PublicService.domainCheck({ domain: domain.toLowerCase() })
      
      if (!check.valid) {
        throw new Error("Invalid domain")
      }

      const baseDomain = getBaseDomain()
      const port = window.location.port ? `:${window.location.port}` : ""
      const targetHost = check.instance_domain?.trim() || `${domain.toLowerCase()}.${baseDomain}`

      window.location.href = `${window.location.protocol}//${targetHost}${port}/login`
    } catch (error) {
      toast({
        title: "Nie znaleziono obszaru roboczego",
        description: "Nie udało nam się znaleźć obszaru roboczego o tej nazwie. Sprawdź dane i spróbuj ponownie.",
        status: "error",
        duration: 4000,
        isClosable: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Container maxW="sm" h="100vh" centerContent justifyContent="center">
      <Stack spacing={8} w="full">
        <Stack spacing={2} textAlign="center">
          <Heading size="lg">Find your company</Heading>
          <Text color="gray.600">Enter your workspace name to continue</Text>
        </Stack>
        
        <Stack spacing={4}>
          <FormControl id="domain">
            <FormLabel>Workspace name</FormLabel>
            <Input 
              placeholder="e.g. mycompany" 
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleContinue()}
              autoFocus
            />
            <Text fontSize="sm" mt={2} color="gray.500">
              .dbgone.com
            </Text>
          </FormControl>
          
          <Button 
            colorScheme="teal" 
            isLoading={isLoading} 
            onClick={handleContinue}
            isDisabled={!domain}
          >
            Continue
          </Button>

          <Stack pt={4} textAlign="center">
            <Text color="gray.600">Nie masz jeszcze konta?</Text>
            <Link as={RouterLink} to="/register-company" color="blue.500" fontWeight="bold">
              Zarejestruj swoją firmę
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  )
}
